import document_received_json from './document-received.json';
import need_signature_json from './need-signature.json';
import send_allianz_json from './send-to-allianz.json';

export default {
  'changed-document-status': {
    ...document_received_json,
    ...need_signature_json,
    ...send_allianz_json,
  },
};
